import { Component, OnInit, Input } from '@angular/core';
import { RoomService } from '../../../../shared/services/rest/room.service';
import { Room } from '../../../../shared/models/room.model';
import { BuildingService } from '../../../../shared/services/rest/building.service';
import { Building } from '../../../../shared/models/building.model';
import { StringHelper } from '../../../../shared/utils/string-helper';
import { MessageService } from 'src/app/shared/services/message.service';
import { MessageType } from 'src/app/shared/models/message';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpHelper } from 'src/app/shared/utils/http-helper';
import { TranslateService } from '@ngx-translate/core';
import { BaseInfoComponent } from './base-info.component';

@Component({
  selector: 'app-room-info',
  templateUrl: './base-info.component.html',
  styleUrls: ['./base-info.component.scss']
})
export class RoomInfoComponent extends BaseInfoComponent implements OnInit {

  /**
   * Id of the room to display (required)
   *
   * @type {number}
   * @memberof RoomInfoComponent
   */
  @Input() roomId: number;

  constructor(
    private room: RoomService,
    building: BuildingService,
    messages: MessageService,
    translation: TranslateService
  ) {
    super(building, messages, translation);
  }

  ngOnInit() {
    if (!this.roomId) {
      throw new Error('The property "roomId" is required on RoomInfoComponent');
    }

    this.loadData();
  }

  get id(): number {
    return this.roomId;
  }

  get typePrefix(): string {
    return 'ROOM';
  }

  /**
   * Load data from REST-Api
   *
   * @private
   * @memberof RoomInfoComponent
   */
  protected onLoadData() {
    // room
    this.room.get(String(this.roomId)).toPromise().then(
      (d) => {
        const room = <Room>d;
        // building
        this.building.get(String(room.BuildingId)).toPromise().then(
          (b) => {
            const building = Building.create(<Building>b);
            this.initData(room, building);

            this.isLoading = false;
          },
          () => {
            this.translation.get('BUILDING_NOT_FOUND', { id: this.roomId }).subscribe(
              (text: string) => { this.messages.add(text, MessageType.Error); }
            );

            this.isLoading = false;
          });
      },
      (error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.hasNoPermission = true;
        } else {
          this.translation.get('ROOM_NOT_FOUND', { id: this.roomId }).subscribe(
            (text: string) => { this.messages.add(text, MessageType.Error); }
          );
        }
        this.isLoading = false;
      });

  }

  /**
   * Map loaded data to model
   *
   * @private
   * @param {Room} room
   * @param {Building} building
   * @memberof RoomInfoComponent
   */
  private initData(room: Room, building: Building) {
    this.data = {
      Ressource: {
        Text: [room.Designation, room.RoomType, room.Description].filter((e) => e).join('<br>'),
        NumberPersons: room.NumberPersons
      },
      Infrastructure: room.RoomEquipments.map(x => x.Designation).join(', '),
      Remark: StringHelper.nl2br(StringHelper.stringOrEmpty(room.Memo).trim()),
      RessourceUrl: room.Url ? HttpHelper.ensureHttpPrefix(room.Url) : '',
      Site: building.Site,
      Building: {
        Designation: building.Designation,
        Url: building.Url ? HttpHelper.ensureHttpPrefix(building.Url) : null,
        Floor: room.Floor
      },
      Address: [
        StringHelper.stringOrEmpty(building.Address).trim(),
        (StringHelper.stringOrEmpty(building.Zip) + ' ' + StringHelper.stringOrEmpty(building.Location)).trim()
      ].join('<br>')
    };

    this.initMapLink(building.Address, StringHelper.stringOrEmpty(building.Zip), StringHelper.stringOrEmpty(building.Location));
  }

}
